import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { client as apollo } from 'cccisd-apollo';
import { DeploymentPlayer } from 'cccisd-laravel-assignment';
import Loader from 'cccisd-loader';
import Axios from 'cccisd-axios';
import groupQuery from './groupQuery.graphql';
import _get from 'lodash/get';

const Boilerplate = window.cccisd.boilerplate;

const YouthAssessment = props => {
    const { match } = props;
    const [list, setList] = useState(null);
    const [deployment, setDeployment] = useState(null);
    const [pawn, setPawn] = useState(null);
    const [loading, setLoading] = useState(true);

    const [show404, setShow404] = useState(null);

    useEffect(() => {
        let { groupId, deploymentHash, shortHash } = match && match.params;
        async function fetchData() {
            try {
                const res = await apollo.query({
                    query: groupQuery,
                    fetchPolicy: 'network-only',
                    variables: { groupId, deploymentHash, shortHash },
                });

                const groupList = getGroupList(res.data);
                setList(groupList);

                setDeployment(res.data.flows.deployment || null);
                setPawn(res.data.roles.anyRole.pawn || null);

                // if no shorthash, then create call createAndSetAnon
                // to create anon pawn
                if (!shortHash) {
                    await createAndSetAnon(res.data.flows.deployment);
                }

                setLoading(false);
            } catch (error) {
                console.error(error);
                setShow404(true);
            }
        }
        fetchData();
    }, []);

    const createAndSetAnon = async deploymentData => {
        const { history } = props;

        try {
            let response = await Axios.post(
                Boilerplate.route('api.assignmentDeployment.addDeploymentAnon', {
                    deploymentId: deploymentData.deploymentId,
                })
            );

            const responsePawn = _get(response, 'data.data');
            if (responsePawn && responsePawn.id) {
                setPawn({
                    pawnId: responsePawn.id,
                    pawnHash: responsePawn.random_hash,
                });
                // update url with new pawn hash
                const updatedUri = `${match.url}/${responsePawn.respondent_hash}`;
                history.push(updatedUri);
            } else {
                setShow404(true);
            }
        } catch (error) {
            console.error(error);
            setShow404(true);
        }
    };

    const getGroupList = data => {
        const {
            groups: { classList },
        } = data;

        return classList.map(item => {
            const siteLabel = item.parentGroup.site.group.label;
            const id = item.group.groupId;
            const name = `${siteLabel} - ${item.group.label}`;
            return {
                id,
                name,
            };
        });
    };

    if (show404) {
        return (
            <div className="not-found">
                <h2>404 ERROR</h2>
                <div style={{ marginBottom: '1em' }}>Sorry, an error has occurred. Requested page not found!</div>
            </div>
        );
    }
    if (loading) {
        return <Loader loading />;
    }

    if (list) {
        let componentProps = {
            ...props,
            flowProps: {
                hidePlayButton: true,
                variables: {
                    groupList: list,
                },
            },
        };

        if (pawn) {
            componentProps = {
                ...componentProps,
                deploymentId: deployment.deploymentId,
                deploymentHandle: deployment.deploymentHandle,
                pawnId: pawn.pawnId,
                pawnHash: pawn.pawnHash,
            };

            return (
                <>
                    <DeploymentPlayer {...componentProps} />
                </>
            );
        }
    }
    return null;
};

YouthAssessment.propTypes = {
    match: PropTypes.object,
};

export default YouthAssessment;
